export default "__VITE_ASSET__DoP6$3Gk__"